import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { axiosInstance } from 'hooks/auth/AxiosInstance';

type CorrectCaseCheckerPlatePayload = {
  fineId: string;
  vehicleRegistrationNumber: string;
  reason: string;
};

type CorrectCaseCheckerLocationPayload = {
  fineId: string;
  location: string;
  roadName: string;
  city: string;
  gps: string;
  reason: string;
};

type CorrectCaseCheckerFinePayload =
  | CorrectCaseCheckerPlatePayload
  | CorrectCaseCheckerLocationPayload;

type CorrectCaseCheckerFineResponse = {
  error: boolean;
  message: string;
};

const correctCaseCheckerFine = async ({
  fineId,
  ...body
}: CorrectCaseCheckerFinePayload): Promise<CorrectCaseCheckerFineResponse> => {
  const response = await axiosInstance.patch(`fine/${fineId}`, body);

  return response.data;
};

const useCorrectCaseCheckerPlate = (): UseMutationResult<
  CorrectCaseCheckerFineResponse,
  Error,
  CorrectCaseCheckerFinePayload
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: correctCaseCheckerFine,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fine'] });
      queryClient.invalidateQueries({ queryKey: ['fines'] });
      queryClient.invalidateQueries({
        queryKey: ['case-checker-pending-cases'],
      });
    },
    onError: (error: Error) => {
      console.error('Error correcting case checker fine:', error.message);
    },
  });
};

export default useCorrectCaseCheckerPlate;
